import React from 'react';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';

type RadioProps = {
  defaultChecked?: boolean;
  disabled?: boolean;
  label?: string;
  onChange: (checked: boolean) => void;
};

const Radio: React.FC<RadioProps> = ({
  label = '',
  defaultChecked = false,
  onChange,
  disabled = false,
}) => {
  let isChecked = defaultChecked;

  const handleCheckboxChange = (checked: boolean) => {
    onChange(checked);
  };

  return (
    <div className="div-container">
      <label className="label-container">{label}</label>
      <Switch
        disabled={disabled}
        checked={isChecked}
        onChange={handleCheckboxChange}
        className={isChecked ? 'checked' : 'unchecked'}
      />
    </div>
  );
};

export default Radio;
